__turbopack_context__.v({
  "-letter": "fortune-module__iGiX9a__-letter",
  "-letter-extra-tight": "fortune-module__iGiX9a__-letter-extra-tight",
  "-letter-tight": "fortune-module__iGiX9a__-letter-tight",
  "bg": "fortune-module__iGiX9a__bg",
  "btn": "fortune-module__iGiX9a__btn",
  "shadow": "fortune-module__iGiX9a__shadow",
  "text_container": "fortune-module__iGiX9a__text_container",
});
